import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { AppIcons } from '../utils/icons';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

const appviaUserSettingsNavItem = userSettingsPlugin
  .getExtension('nav-item:user-settings')
  .override({
    params: {
      icon: AppIcons.settings as IconComponent,
    },
  });

export const appviaUserSettingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [appviaUserSettingsNavItem],
});
